// AdminAuthGuard.js
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { authPrefixedRoutes } from '../../routes/all-routes/authRoutes';

const AdminAuthGuard = ({ children }) => {
  const navigate = useNavigate();
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const user = useSelector(state => state.auth.user);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(authPrefixedRoutes.LOGIN);
      toast.error('You are not logged in');
    } else if (user && user.panel !== 'admin') {
      navigate(authPrefixedRoutes.LOGIN);
      toast.error('You do not have admin privilege');
    }
  }, [isAuthenticated, user, navigate]);

  return isAuthenticated && user && user.panel === 'admin' ? children : null;
};

export default AdminAuthGuard;
